module.exports = __webpack_public_path__ + "static/media/heart_filled.64f938d7.svg";